import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { OptionColorPipe } from '@df/ui/common/option-color.pipe';
import { OptionImagePipe } from '@df/ui/common/option-image.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { SwiperModule } from 'swiper/angular';

@Component({
    selector: 'horse-color-selector',
    templateUrl: './horse-color-selector.html',
    styleUrls: ['./horse-color-selector.scss'],
    standalone: true,
    imports: [TranslationModule, OptionLabelPipe, OptionColorPipe, OptionImagePipe, DfImageDirective, SwiperModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HorseProfileColorSelectorComponent extends UiComponent implements OnChanges {
    @Input()
    selectedColor?: number | undefined;

    @Input()
    title?: string = 'What’s your horse colour?';

    @Input()
    attributeCode: string = 'horse_colour';

    @Output()
    selectedColorChange = new EventEmitter<number>();

    private attributeResource = inject(AttributeResource);

    protected currentSelectedColor: number | undefined = undefined;

    override ngOnInit(): void {
        this.currentSelectedColor = this.selectedColor;
    }

    override ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedColor']) {
            this.currentSelectedColor = this.selectedColor || 0;
        }
    }

    protected isColorSelected(optionId: number): boolean {
        return this.currentSelectedColor === optionId;
    }

    protected toggleColor(optionId: number): void {
        this.currentSelectedColor = this.currentSelectedColor === optionId ? undefined : optionId;
        this.selectedColorChange.emit(this.currentSelectedColor);
    }

    get colorOptions(): number[] {
        return this.attributeResource.getExisting(this.attributeCode)?.data?.options?.map(i => i.value) || [];
    }
}
